import { i18n } from "translate/i18n";

export const wrongPassword = i18n.t("messages.authentication.wrongPassword");
export const emailNotFound = i18n.t("messages.authentication.emailNotFound");
export const finishYourRegistration = i18n.t(
  "messages.authentication.finishYourRegistration"
);
